// extracted by mini-css-extract-plugin
module.exports = {"site-wrapper":"layout_site-wrapper__l2oEW","content-wrapper":"layout_content-wrapper__glXht"};